import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const replicate = defineConnector({
  identifier: "replicate",
  name: "Replicate",
  tagLine: "AI model hosting",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.replicate\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your Replicate API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Go to your [Replicate account settings](https://replicate.com/account/api-tokens) and create a new API token.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Replicate account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The API key for your Replicate account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.replicate.com/v1/account",
  },
});
